import { render, staticRenderFns } from "./activeDetail.vue?vue&type=template&id=a1e7cdce&scoped=true"
import script from "./activeDetail.vue?vue&type=script&lang=js"
export * from "./activeDetail.vue?vue&type=script&lang=js"
import style0 from "./activeDetail.vue?vue&type=style&index=0&id=a1e7cdce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e7cdce",
  null
  
)

export default component.exports